<template>
  <div>
    <div class="contenido-informacion">
      <div class="imagen">
        <img :src="foto" alt="imagen del terapeuta" class="img-responsive img-ter" style="border:none;" />
      </div>
      <div class="informacion">
        <br> <br>
        <h1 class="nombre-ter">{{ nombre }} </h1>
        <span class="rol-ter">{{ usuario }}</span> <br>
        <span>@{{ nombreUsuario.toLowerCase() }}</span> <br> <br>
        <button style="border-radius: 7px; background-color: #e3097e; color: white; border: none;''; padding: 10px 20px; font-size: 16px; font-weight: 500;"> Actualizar información </button>
      </div>
    </div>

    <div class="card-contenido" style="display: flex; gap: 20px;">
      <!-- <div class="col-md-12">
        <br>
        <br>
        <span class="titulo"">Actividad hoy</span>
      </div> -->
      <!-- <div class="col-xs-12 col-sm-6 col-md-3" v-for="card in card_dia2" :key="card.title">
        <br>
        <br>
        <stats-card style="border-radius: 8px; border:none;">
          <div class="icon-big text-center" slot="header">
            <img :src="card.img" v-if="card.img != ''" :alt="card.title" />
            <i style="color: #e3097e" v-else :class="card.icon"></i>
          </div>
          <div class="numbers" slot="content">
            <strong>
              <p style="color: grey">{{ card.title }}</p>
            </strong>
            <strong style="font-size: 50px">{{ card.value }}</strong>
          </div>
        </stats-card>
      </div> -->
      <div class="card-proxima-sesion">
        <div class="card-evento">
          <div class="informacion">
            <div>PRÓXIMA SESIÓN</div> <br>
            <div class="paciente">SALOMON PALACIO BARBA</div>
            <div class="fecha">{{ fechaProxima | date }}, 11:00 a 11:30</div>
          </div>
          <div class="accion">
            <button class="button-sesion">
              Registrar evolución
            </button>
          </div>
        </div>
      </div>
      <div class="card-resumen-dia">
        <div class="card-resumen">
            <div class="titulo-resumen">Resumen del día</div>
            <div class="resumen">
              <div class="informacion-resumen">
                <span>22 Sesiones programadas</span>
                <span>5 Sesiones realizadas</span>
                <span>17 Sesiones pendientes</span>
              </div>
            </div>
        </div>
        <div class="accion-resumen">
                <center>
                  <div class="mes">
                  {{ fechaActualSeparada.mes.toUpperCase() }}, {{ fechaActualSeparada.year }}
                </div>
                <div class="dia">
                  {{ fechaActualSeparada.dia }}
                </div>
                </center>
              </div>
      </div>
    </div>
    <div class="row">
      <br> <br>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <span style="font-size: 18px; font-weight: 500;">Objetivos activos</span>
          </div>
          <div class="card-content">
            <div class="row">
              <div class="col-md-12">
                <br>
                <el-table class="table-striped table-condensed table-responsive" :data="objetivosProximosPag">
                  <el-table-column label="Paciente" width="350">
                    <template slot-scope="props">
                      <small class="grey-text">{{
                        props.row.nombrePaciente + " " + props.row.apellidoPaciente
                      }}</small>
                    </template>
                  </el-table-column>
                  <el-table-column label="Fec. Ingreso" width="150">
                    <template slot-scope="props">
                      <span class="grey-text">{{ props.row.fecha }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Fec. Finalización" width="150">
                    <template slot-scope="props">
                      <span class="grey-text">{{ props.row.fechaCumplimiento }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Objetivo" width="440">
                    <template slot-scope="props">
                      <span class="grey-text">{{ props.row.objetivo }}</span>
                    </template>
                  </el-table-column>
                </el-table>
               
            <p-pagination v-model="paginationProximo.currentPage" :per-page="paginationProximo.perPage"
              :total="paginationProximo.total"></p-pagination>

              </div>
            </div>
          </div>
         
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <span style="font-size: 18px; font-weight: 500;">Pacientes liderados</span>
            <div style="display: flex; margin-top: 10px; justify-content: space-between;">
              <input type="text" class="form-control" style="width: 300px;" v-model="searchPaciente" placeholder="Buscar paciente..." />
              <download-excel class="btn btn-simple" style="border-radius: 7px; color:green; font-size: 18px; font-weight: 500;"
                  :data="pacientesCargo" :fields="json_fieldsPacientes" worksheet="My Worksheet"
                  v-if="pacientesCargo != ''" :name="'pacientesACargo' + fechaActual">
                  <i class="fa fa-download"></i> Exportar
                </download-excel>
            </div>
            
            <!-- <div class="row">
              <div class="col-xs-10 col-md-6 caja-titulo">
                <strong class="card-title">Pacientes liderados </strong>
              </div>
              <div class="col-xs-12 col-md-3">
                <input type="text" class="form-control" v-model="searchPaciente" placeholder="Buscar paciente..." />
              </div>
              <div class="col-sx-12 col-md-2">
                <download-excel class="btn btn-success btn-fill pull-left" style="border-radius: 7px"
                  :data="pacientesCargo" :fields="json_fieldsPacientes" worksheet="My Worksheet"
                  v-if="pacientesCargo != ''" :name="'pacientesACargo' + fechaActual">
                  Exportar a excel
                </download-excel>
              </div>
            </div> -->
          </div>
          <div class="card-content">
            <el-table border class="el-table table-striped table-condensed table-responsive" :data="pacientesCargoPag"
              >
              <el-table-column label="Nombres y Apellidos" width="450">
                <template slot-scope="props">
                  <span style="font-size: 13px; color: grey">{{
                    props.row.PacApe1 + " " + props.row.PacNom1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Edad" width="160">
                <template slot-scope="props">
                  <span class="grey-text">{{
                    calcularEdad(props.row.PacFecNac)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Numero de documento" width="150">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.PacNumDoc }}</span>
                </template>
              </el-table-column>
              <el-table-column  label="DX" width="280">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.dx }}</span>
                </template>
              </el-table-column>
            </el-table>
            
           
            <p-pagination v-model="paginationPacienteCargo.currentPage"
              :per-page="paginationPacienteCargo.perPage" :total="paginationPacienteCargo.total"></p-pagination>

          </div>
          
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
  
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-xs-10 col-md-10">
                <span style="font-size: 18px; font-weight: 500;">Sesiones realizadas por fecha</span>
              </div>
            </div>
          </div>
          <div class="card-content" style="margin-top:10px; margin-left: 3px;">
            <div class="row">
              <div class="col-md-3">
                <label>Fecha inicio:</label>
                <input type="date" v-model="fechaInicioHis" class="form-control" />
              </div>
              <div class="col-md-3">
                
                <label>Fecha fin:</label>
                <input type="date" v-model="fechaFinHis" class="form-control" />
              </div>
              <div class="col-md-3">
                
                <small style="color: white">jj</small> <br />
                <button class="btn btn-success" @click="hisSesiones()" style="border-radius: 0px">
                  Buscar atenciones
                  <i class="fa fa-search"></i>
                </button>
              </div>
              <div class="col-md-3">
                <small style="color: white">jj</small> <br />
                <br />
                <download-excel class="btn btn-success btn-fill" style="border-radius: 0px" :data="hisAtenciones"
                  :fields="json_fieldsAtenciones" worksheet="My Worksheet" v-if="hisAtenciones != ''"
                  :name="'sesionesRealizadas' + fechaActual">
                  Exportar a excel
                </download-excel>
              </div>
            </div>
            <br>
            <el-table class="el-table table-striped table-condensed table-responsive" :data="sesionesRRPag">
              <el-table-column label="Nombres y Apellidos" width="400">
                <template slot-scope="props">
                  <span style="font-size: 13px; color: grey">{{
                    props.row.PacApe1 + " " + props.row.PacNom1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Entidad del paciente" width="250">
                <template slot-scope="props">
                  <span style="font-size: 13px; color: grey">{{
                    props.row.entidad
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Fecha de atención">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.ProFec | date }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Hora">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.hora }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Lugar">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.ProLug }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Tipo">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.ProTip }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Valor">
                <template slot-scope="props">
                  <span class="grey-text">{{ formatearPesosColombianos(props.row.ProValTer) }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column width="100" label="Estado">
                <template slot-scope="props">
                  <span class="grey-text">{{ props.row.estado }}</span>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <div class="card-footer">
            <p-pagination class="pull-right" v-model="paginationSesionesRR.currentPage"
              :per-page="paginationSesionesRR.perPage" :total="paginationSesionesRR.total"></p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import StatsCard from "src/components/UIComponents/Cards/StatsCard.vue";
import formatearPesosColombianos from "../../global-services/formatear-pesos";
import axios from "axios";

import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    StatsCard,
    PPagination,
  },
  computed: {
    pagedDataPendiente() {
      return this.objetivosPendientes.slice(
        this.fromPendiente,
        this.toPendiente
      );
    },
    objetivosPendientesPag() {
      if (!this.searchQuery) {
        this.paginationPendiente.total = this.objetivosPendientes.length;
        return this.pagedDataPendiente;
      }
      let result = this.objetivosPendientes.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.paginationPendiente.total = result.length;
      return result.slice(this.fromPendiente, this.toPendiente);
    },
    toPendiente() {
      let highBound = this.fromPendiente + this.paginationPendiente.perPage;
      if (this.totalPendiente < highBound) {
        highBound = this.totalPendiente;
      }
      return highBound;
    },
    fromPendiente() {
      return (
        this.paginationPendiente.perPage *
        (this.paginationPendiente.currentPage - 1)
      );
    },
    totalPendiente() {
      this.paginationPendiente.total = this.objetivosPendientes.length;
      return this.objetivosPendientes.length;
    },

    // pacientes a cargo <paginación>
    pagedDataPacientesCargo() {
      return this.pacientesCargo.slice(
        this.fromPacienteCargo,
        this.toPacienteCargo
      );
    },
    pacientesCargoPag() {
      if (!this.searchPaciente) {
        this.paginationPacienteCargo.total = this.pacientesCargo.length;
        return this.pagedDataPacientesCargo;
      }
      let result = this.pacientesCargo.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchPaciente.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.paginationPacienteCargo.total = result.length;
      return result.slice(this.fromPacienteCargo, this.toPacienteCargo);
    },
    toPacienteCargo() {
      let highBound =
        this.fromPacienteCargo + this.paginationPacienteCargo.perPage;
      if (this.totalPacienteCargo < highBound) {
        highBound = this.totalPacienteCargo;
      }
      return highBound;
    },
    fromPacienteCargo() {
      return (
        this.paginationPacienteCargo.perPage *
        (this.paginationPacienteCargo.currentPage - 1)
      );
    },
    totalPacienteCargo() {
      this.paginationPacienteCargo.total = this.pacientesCargo.length;
      return this.pacientesCargo.length;
    },
    // objetivos proximos <paginación>
    pagedDataObjetivosProximos() {
      return this.objetivosActivos.slice(
        this.fromObjetivosProximos,
        this.toObjetivosProximos
      );
    },
    objetivosProximosPag() {
      if (!this.searchQuery) {
        this.paginationProximo.total = this.objetivosActivos.length;
        return this.pagedDataObjetivosProximos;
      }
      let result = this.objetivosActivos.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.paginationProximo.total = result.length;
      return result.slice(this.fromObjetivosProximos, this.toObjetivosProximos);
    },
    toObjetivosProximos() {
      let highBound =
        this.fromObjetivosProximos + this.paginationProximo.perPage;
      if (this.totalObjetivosProximo < highBound) {
        highBound = this.totalObjetivosProximo;
      }
      return highBound;
    },
    fromObjetivosProximos() {
      return (
        this.paginationProximo.perPage *
        (this.paginationProximo.currentPage - 1)
      );
    },
    totalObjetivosProximo() {
      this.paginationProximo.total = this.objetivosActivos.length;
      return this.objetivosActivos.length;
    },

    // sesiones realizadas <paginación>
    pagedDataSesionesRR() {
      return this.hisAtenciones.slice(this.fromSesionesRR, this.toSesionesRR);
    },
    sesionesRRPag() {
      if (!this.searchQuery) {
        this.paginationProximo.total = this.hisAtenciones.length;
        return this.pagedDataSesionesRR;
      }
      let result = this.hisAtenciones.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.paginationSesionesRR.total = result.length;
      return result.slice(this.fromSesionesRR, this.toSesionesRR);
    },
    toSesionesRR() {
      let highBound = this.fromSesionesRR + this.paginationSesionesRR.perPage;
      if (this.totalSesionesRR < highBound) {
        highBound = this.totalSesionesRR;
      }
      return highBound;
    },
    fromSesionesRR() {
      return (
        this.paginationSesionesRR.perPage *
        (this.paginationSesionesRR.currentPage - 1)
      );
    },
    totalSesionesRR() {
      this.paginationSesionesRR.total = this.hisAtenciones.length;
      return this.hisAtenciones.length;
    },
  },
  data: () => ({
    searchQuery: "",
    fechaActual: "",
    fechaFin: "",
    paginationPendiente: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
    paginationProximo: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
    searchPaciente: "",
    paginationPacienteCargo: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
    paginationSesionesRR: {
      perPage: 50,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
    propsToSearch: [
      "PacNom1",
      "PacApe1",
      "PacNumDoc",
      "PacFecNac",
      "PacFecIng",
    ],
    ip: "https://avanti-erp.com/",
    pacientesCargo: [],
    objetivosProximos: [],
    objetivosPendientes: [],
    hisAtenciones: [],
    foto: `https://avanti-erp.com/${localStorage.getItem("foto")}`,
    usuario: "",
    nombre: localStorage.getItem("nombre"),
    especialidad: '',

    fechaInicioHis: "",
    fechaFinHis: "",
    fechaProxima: '2025-11-12',
    fechaActualSeparada: '',
    nombreUsuario: '',
    card_dia: [
      {
        title: "SSP Sede",
        value: 0,
        icon: "fa fa-play",
        img: "static/img/ICONOS/consulta virtual.svg",
      },
      {
        title: "SSP Domicilio",
        value: 0,
        icon: "fa fa-users",
        img: "static/img/ICONOS/familia.svg",
      },
      {
        title: "SSP Totales",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSPP.svg",
      },
    ],
    card_dia2: [
      {
        title: "SSR sede",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/consulta virtual.svg",
      },
      {
        title: "SSR domicilio",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/AARR.svg",
      },
      {
        title: "SSR Cancel.",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSCC.svg",
      },
      {
        title: "SSR Totales",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSPP.svg",
      },
    ],
    // config JsonExcel
    objetivosActivos: [],
    json_fieldsProximos: {
      Nombres: "PacNom1",
      Apellidos: "PacApe1",
      "Fecha objetivo": "ObjFec",
      "Fecha fin objetivo": "ObjFecCum",
      Objetivo: "ObjObj",
    },
    json_fieldsPacientes: {
      Nombres: "PacNom1",
      Apellidos: "PacApe1",
      "Numero Documento": "PacNumDoc",
      Edad: "Edad",
      Dx: "dx",
      "Terapeuta": 'Terapeuta',
      "Especialidad": 'Especialidad'
    },
    json_fieldsAtenciones: {
      Nombres: "PacNom1",
      Apellidos: "PacApe1",
      "Fecha de atención": "ProFec",
      hora: "hora",
      "hora fin" : "horaFin",
      Lugar: "ProLug",
      "Tipo": "ProTip",
      "Valor": "ProValTer",
    },
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
  }),
  methods: {
    formatearPesosColombianos,
    getEvents() {
      let fechaF = this.fechamasdias(this.fechaActual);
      axios
        .get(
          `https://www.googleapis.com/calendar/v3/calendars/${localStorage.getItem(
            "email"
          )}/events?key=AIzaSyCS6MXgvS2kJs7YaIkUfFGx2O1fI9BKuC0&timeMin=${this.fechaActual
          }T00:00:00-05:00&timeMax=${fechaF}T00:00:00-05:00&maxResults=100`
        )
        .then((res) => {
          let datos = res.data.items;
          let domicilio = 0;
          let virtual = 0;
          datos.forEach((element) => {
            let tuDate1 = new Date();
            let tuDate2 = new Date(element.start.dateTime);

            let a = new Date(
              tuDate1.getFullYear(),
              tuDate1.getMonth(),
              tuDate1.getDate()
            );
            let b = new Date(
              tuDate2.getFullYear(),
              tuDate2.getMonth(),
              tuDate2.getDate()
            );

            if (element.location) {
              if (+a == +b) {
                virtual =
                  virtual +
                  this.calcularMinutos(
                    this.horaFormateada(element.start.dateTime),
                    this.horaFormateada(element.end.dateTime)
                  );
                // console.log()
              }
            } else {
              if (+a == +b) {
                domicilio =
                  domicilio +
                  this.calcularMinutos(
                    this.horaFormateada(element.start.dateTime),
                    this.horaFormateada(element.end.dateTime)
                  );
              }
            }
          });
          this.card_dia[1].value = domicilio;
          this.card_dia[0].value = virtual;
          this.card_dia[2].value = domicilio + virtual;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    horaFormateada(fecha) {
      var hora = new Date(fecha).getHours();
      var minutos = new Date(fecha).getMinutes();
      if (minutos == 0) {
        minutos = "00";
      }
      var horaFormateada = hora + ":" + minutos;
      return horaFormateada;
    },
    calcularMinutos(inicio, fin) {
      // Cogemos la hora inicial y final y obtenemos los minutos totales
      var horaInicial = this.devolverMinutos(inicio);
      var horaFinal = this.devolverMinutos(fin);

      if (horaInicial < horaFinal) {
        // Restamos los minutos finales con los minutos iniciales

        // console.log(
        //   "La cantidad de sesiones que se necesita es: " + (horaFinal - horaInicial / 60) + " sesion"
        // );
        let sesiones = (horaFinal - horaInicial) / 30;

        return Math.trunc(sesiones);
      } else {
        // document.getElementById("resultado").innerHTML =
        //   "La hora inicial tiene que ser inferior a la hora final";
      }
      // console.log(inicio)
    },
    devolverMinutos(horaMinutos) {
      return (
        parseInt(horaMinutos.split(":")[0]) * 60 +
        parseInt(horaMinutos.split(":")[1])
      );
    },
    fechamasdias: function (fecha) {
      var fecha = new Date(fecha);
      fecha.setDate(fecha.getDate() + 10);
      // console.log("fecha más 7 días", fecha);

      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      return fechaFormateada;
    },
    calcularFechaActual() {
      const fecha_hoy = new Date();

      // Convertir a fecha local sin desfasar por UTC
      const fecha_local = new Date(fecha_hoy.getTime() - fecha_hoy.getTimezoneOffset() * 60000);
      
      const ahora_ano = fecha_local.getFullYear();
      const ahora_mes = String(fecha_local.getMonth() + 1).padStart(2, "0");
      const ahora_dia = String(fecha_local.getDate()).padStart(2, "0");

      this.fechaActual = `${ahora_ano}-${ahora_mes}-${ahora_dia}`;
      console.log(this.fechaActual, "fecha actual");
      this.fechaFin = this.fechamasdias(this.fechaActual);
      this.fechaActualSeparada = this.obtenerMesYDia(this.fechaActual);
      // this.objetivosProximosFun();
      // this.getEvents();
    },
    objetivosActivosFun: async function(){
      try{
        this.$modal.show('carga')
        const BASE_URL = `${this.ip}api/objetivos-activos/${localStorage.getItem("usuario")}`;
        const response = await axios.get(BASE_URL);
        this.objetivosActivos = response.data.data;
      }catch(error){
        console.log(error);
      }finally{
        this.$modal.hide('carga')
      }
    },
    pacientesCargoFun: function () {
      const BASE_URL = `${this.ip}api/pacientesCargo/${localStorage.getItem(
        "usuario"
      )}/${localStorage.getItem("rol")}`;
      axios
        .get(BASE_URL)
        .then((res) => {
          if (res.data.status == true) {
            let datos = res.data.data;
            let datos_f = [];
            this.pacientesCargo = res.data.data;
            for (let index = 0; index < datos.length; index++) {
              datos_f.push({
                PacApe1: datos[index].PacApe1,
                PacNom1: datos[index].PacNom1,
                PacFecNac: datos[index].PacFecNac,
                PacNumDoc: datos[index].PacNumDoc,
                Edad: this.calcularEdad(datos[index].PacFecNac),
                dx: datos[index].dx,
                Terapeuta: this.nombre,
                Especialidad: this.especialidad
              });

              this.pacientesCargo = datos_f;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    hisSesiones: function () {
      const BASE_URL = `${this.ip}api/hisSesiones/${localStorage.getItem(
        "usuario"
      )}/${this.fechaInicioHis}/${this.fechaFinHis}`;
      axios
        .get(BASE_URL)
        .then((res) => {
          if (res.data.status == true) {
            this.hisAtenciones = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    hisSesionesHoy: function () {
      const BASE_URL = `${this.ip}api/hisSesionesHoy/${localStorage.getItem(
        "usuario"
      )}/${localStorage.getItem("email")}/${this.fechaActual}`;
      axios
        .get(BASE_URL)
        .then((res) => {
          if (res.data.status == true) {
            this.card_dia2[0].value = res.data.terapiasV;
            this.card_dia2[1].value = res.data.terapiasD;
            this.card_dia2[2].value = res.data.terapiasC;
            this.card_dia2[3].value =
              res.data.terapiasV + res.data.terapiasD + res.data.terapiasC;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    calcularEdad(fecha) {
      var fechaNacimiento = fecha;
      var values = fechaNacimiento.split("-");
      var dia = values[2];
      var mes = values[1];
      var ano = values[0];

      var fecha_hoy = new Date();
      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      // this.fechaIngreso = fechaActual;

      var edad = ahora_ano + 0 - ano;
      if (ahora_mes < mes) {
        edad--;
      }
      if (mes == ahora_mes && ahora_dia < dia) {
        edad--;
      }
      if (edad > 1900) {
        edad -= 1900;
      }

      // calculamos los meses
      var meses = 0;
      if (ahora_mes > mes) meses = ahora_mes - mes;
      if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
      if (ahora_mes == mes && dia > ahora_dia) meses = 11;

      // calculamos los dias
      var dias = 0;
      if (ahora_dia > dia) dias = ahora_dia - dia;
      if (ahora_dia < dia) {
        var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
        var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
      }

      return edad + " años y " + meses + " meses";
    },

    obtenerMesYDia(fechaInput) {
      const mesesAbreviados = [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ];

      const fecha = new Date(fechaInput);

      if (isNaN(fecha)) {
        throw new Error("Fecha inválida");
      }

      const mes = mesesAbreviados[fecha.getMonth()];
      const dia = fecha.getDate()+1;
      const year = fecha.getFullYear();

      return {
        mes,
        dia,
        year
      };
    },

    push: function (route) {
      this.$router.push(route);
    },
  },
  mounted() {
    this.calcularFechaActual();
    this.pacientesCargoFun();
    this.hisSesionesHoy();
    this.objetivosActivosFun();
    this.fechamasdias();
    this.nombreUsuario = localStorage.getItem("usuario");
    let rol = localStorage.getItem("rol");
    if (rol == 2) {
      this.usuario = "Fisioterapeuta";
      this.especialidad = 'Fisioterapia'
    } else if (rol == 3) {
      this.usuario = "Fonoaudiólogo";
      this.especialidad = 'Fonoaudiología'
    } else if (rol == 4) {
      this.usuario = "Terapeuta Ocupacional";
      this.especialidad = 'Terapia ocupacional'
    } else if (rol == 5) {
      this.usuario = "Terapeuta en educación especial";
      this.especialidad = 'Educación especial';
    } else {
      this.usuario = "Psicólogo";
      this.especialidad = 'Psicología'
    }
    document.title = "Avanti | Mi Espacio";
  },
};
</script>
<style scoped>
.card-title {
  color: #6b6969;
  font-size: 20px;
  font-family: sans-serif;
  font-weight: bold;
}

.line-header {
  color: black;
  height: 5px;
}

.card-name {
  color: #302254;
  font-size: 20px;
  font-family: sans-serif;
}

.caja-titulo {
  padding-top: 1%;
  margin-left: -3%;
}

.img-header {
  width: 70px !important;
}

.img-ter {
  width: 200px;
  height: 250px;
  object-fit: cover;
  border-radius: 7px;
}

.btn {
  border-radius: 5px !important;
}

.rol-ter {
  color:#E3097E;
  font-size: 4rem;
  font-weight: 300;
}

.nombre-ter {
  font-weight: 700;
  margin:0;
}

.contenido-informacion{
  display: flex;
  justify-content: center;
  gap: 45px;
}

.imagen{
  /* border: 0.2rem solid grey; */
  /* padding: 5px; */
  box-shadow: #302254 1px 10px 25px;
  border-radius: 7px;
  /* background-color: white; */
}

@media (max-width: 600px) {
  .contenido-informacion {
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
  }

  .contenido-informacion .imagen img {
    width: 200px;
    height: 250px;
  }
}

.titulo{
  font-size: 2.5rem;
  font-weight: 500;
  color: #302254;
  margin-bottom: 2rem;
}

.card-proxima-sesion{
  margin-top: 40px;
  background: linear-gradient(145deg, #66588a, #3a3450);
  border-radius: 7px;
  width: 50%;
  height: 150px;
  padding: 15px;
}

.card-resumen-dia{
  margin-top: 40px;
  background-color: white;
  border-radius: 7px;
  width: 50%;
  max-height: 150px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
}

.card-evento{
  background: linear-gradient(145deg, #66588a, #3a3450);
  color: #ffffff;
  border-radius: 7px;
  height: 100%;
  padding: 24px;
  display: flex;
  justify-content: space-between;
}

.card-evento .informacion{
  display: flex;
  flex-direction: column;
}

.card-evento .informacion .fecha{
  font-size: 15px;
}

.card-evento .paciente{
  font-size: 20px;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0,0,0,0.9);
}

.card-evento .accion{
  font-size: 12px;
}

.button-sesion {
  background: #ffffff;
  color: #2c2937;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 7px;
  border: 1px solid rgba(0,0,0,0.05);
  cursor: pointer;
  transition: all 0.25s ease;
  font-size: 15px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.button-sesion:hover {
  background: #f4f4f4;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
}

.button-sesion:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.resumen{
  display: flex;
  justify-content: space-between;
  align-items: center;  
}

.resumen .informacion-resumen{
  display: flex;
  flex-direction: column;
}

.resumen .informacion-resumen{
  font-size: 15px;
  color:grey;
  padding-left: 10px;
  padding-top: 15px;
}


.titulo-resumen{
  font-size: 20px;
  color: #302254;
  font-weight: 500;
}

.mes {
  font-size: 20px;
  font-weight: bold;
  color: white;
  padding: 0;
  margin: 0;
}

.dia {
  padding: 0;
  margin: 0;
  font-size: 60px;
  font-weight: 700;
  color: white;
}

.accion-resumen{
  background: linear-gradient(145deg, #8b7ab6, #3a3450);
  padding: 10px;
  border-radius: 7px;
}
</style>


// WEBPACK FOOTER //
// src/components/ADashboard/miEspacio.vue